module.exports = "//public.getcloudapp.com/packs/media/images/team@2x-187056ec16354f86136980fc04bf271f.png";